import _get from "lodash/get";
import { RootState } from "../../../../models";
import { EsimProduct, EsimState } from "../../../../models/state";
import { isOrderNotFound, State as AppState } from "../../app/state/selectors";
import TEXT from "../text-consts";

export type State = AppState & Pick<RootState, "esim">;
const getEsimData = (state: State): Partial<EsimState> => state.esim;

export const getEsimProducts: (state: State) => EsimProduct[] = (state) => getEsimData(state).products || [];

export const getEsimLegalOwnerFullName = (state: State): string =>
    `${_get(getEsimData(state), "legal.firstName", "")} ${_get(getEsimData(state), "legal.lastName", "")}`.trim();

const isAllEsimInstalledAndActive = (state: State): boolean => !!getEsimData(state).isAllEsimInstalledAndActive;

const isAllEsimInstalledButNotAllActive = (state: State): boolean =>
    !!getEsimData(state).isAllEsimInstalledButNotAllActive;

const isMissingEsimInOrder = (state: State): boolean => !!getEsimData(state).isMissingEsimInOrder;

export const getOrderDescription = (state: State): string => {
    let description = "";
    const errorMessage = getEsimData(state).errorMessage;
    if (errorMessage) {
        description = errorMessage;
    } else if (isOrderNotFound(state)) {
        description = TEXT.ERRORS.ORDER_NOT_FOUND;
    } else if (isAllEsimInstalledAndActive(state)) {
        description = TEXT.ERRORS.ALL_INSTALLED_AND_ACTIVE;
    } else if (isAllEsimInstalledButNotAllActive(state)) {
        description = TEXT.ERRORS.INSTALLED_BUT_NOT_ACTIVE;
    } else if (isMissingEsimInOrder(state)) {
        description = TEXT.ERRORS.ORDER_HAS_NON_ESIM;
    }
    return description;
};

export const isB2B = (state: State): boolean => !!getEsimData(state).isB2B;

export const isPhoneNumberVerified = (state: State): boolean => !!getEsimData(state).isPhoneNumberVerified;

export const isLoggedInAsLegal = (state: State): boolean => !!getEsimData(state).isLoggedInAsLegal;

export const getAdminPhoneNumbers = (state: State): string[] => getEsimData(state).adminPhoneNumbers || [];

export const hasProductUserMatch = (state: State): boolean => getEsimData(state).hasProductUserMatch || false;
